import React from 'react';

import GoogleOneTap from '../../../components/GoogleOneTap';
import { useAppSelector } from '../../../stores/redux.store';
import { pageId } from '../constants';
import { useRegisterComponent } from '../../orchestrator';
import { useDynamicConfigs } from '../../../utilities/feature-flags/dynamic-config';
import { AidFrontendDynamicConfig } from '../../../providers/DynamicConfigs';
import { getBooleanDynamicConfigValueOrDefault } from '../../../providers/common';

export const SignupGoogleOneTap = ({ children }: { children: React.ReactNode }) => {
  useRegisterComponent(SignupGoogleOneTap.name);
  const dynamicConfigs = useDynamicConfigs();

  const googleOneTapDismissed = useAppSelector(state => state.googleOneTap.dismissed);
  const hashedCsrfToken = useAppSelector(state => state.hashedCsrfToken);
  const { googleAuthClientId } = useAppSelector(state => state.appConfig);

  const disableOneTap =
    googleOneTapDismissed ||
    getBooleanDynamicConfigValueOrDefault(
      dynamicConfigs,
      AidFrontendDynamicConfig.GOOGLE_ONE_TAP_KILL_SWITCH
    );

  return (
    <GoogleOneTap
      csrfToken={hashedCsrfToken}
      googleAuthClientId={googleAuthClientId}
      source={pageId}
      enabled={!disableOneTap}>
      {children}
    </GoogleOneTap>
  );
};
